module.exports = __webpack_public_path__ + "static/img/fayuan-icon2.2a49c1b4.png";